import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const traditionalItems = ['Cada propiedad pide algo distinto', 'Postulas sin saber si calificas', 'Pierdes tiempo repitiendo todo'];
const ourItems = ['Un estándar claro para todos', 'Sabes tus opciones antes de postular', 'Decides más rápido y con más información'];
export function ComparisonTable() {
  return <section className="py-24 px-6 bg-white" data-id="element-35">
      <div className="max-w-4xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-37">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900" data-id="element-38">
            Ordenar el proceso cambia todo
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-39">
          {/* Traditional Model */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gray-50 rounded-2xl p-8 border border-gray-200" data-id="element-40">
            <h3 className="text-lg font-bold text-gray-900 mb-6" data-id="element-41">
              Proceso desordenado
            </h3>
            <ul className="space-y-4" data-id="element-42">
              {traditionalItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-43">
                  <div className="mt-0.5 bg-red-100 rounded-full p-0.5 shrink-0" data-id="element-44">
                    <X size={14} className="text-red-500" data-id="element-45" />
                  </div>
                  <span className="text-base text-gray-600" data-id="element-46">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Our Model */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-brand-50 rounded-2xl p-8 border border-brand-100" data-id="element-47">
            <h3 className="text-lg font-bold text-gray-900 mb-6" data-id="element-48">
              Proceso con Rentual
            </h3>
            <ul className="space-y-4" data-id="element-49">
              {ourItems.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-50">
                  <div className="mt-0.5 bg-brand-600 rounded-full p-0.5 shrink-0" data-id="element-51">
                    <Check size={14} className="text-white" data-id="element-52" />
                  </div>
                  <span className="text-base text-gray-900 font-medium" data-id="element-53">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}